// extracted by mini-css-extract-plugin
export default {"mainContainer":"uploadSongPage_theme_mainContainer__ma1Ue","titleRow":"uploadSongPage_theme_titleRow__5RdEI"};